import {Component} from 'react';
class DialogService {
    component: any;
    constructor () {
        this.component = undefined;
    }

    confirm = (message: string, details = "Are you sure?", confirmMsg = "Yes", denyMsg = "No") => {
        if (typeof this.component === 'undefined') return Promise.reject(false);
        return new Promise((resolve, reject) => {
            this.component.update(
                { message, details, confirmMsg, denyMsg },
                resolve, reject
            );
        });
    }

    __registerDialogComponent = (component: Component) => {
        this.component = component;
    }
}

let instance = new DialogService();
export default instance;
